import type { FC } from 'react';

import { EndStepCard, EndStepCardProps } from '@eneco/components/flow/EndStep/Card';
import { EndStepHero, EndStepHeroProps } from '@eneco/components/flow/EndStep/EndStepHero';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useFormatter, useTranslation } from '@eneco/i18n';
import { Table } from '@eneco/sparky';

import { useMeterReadingsFlow } from '../../state/MeterReadingsFlow.machine';


interface Props extends EndStepCardProps, EndStepHeroProps {
  footerLabel: string;
}

export const Breakdown: FC<Props> = props => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/global.${label}.${locale}.json`)}>
      <BreakdownComponent {...props} />
    </I18nProvider>
  );
};

export const BreakdownComponent: FC<Props> = ({ heroImage, title, content, buttonHref, buttonText, footerLabel }) => {
  const { state } = useMeterReadingsFlow();
  const { t } = useTranslation();
  const { currency } = useFormatter();

  if (!state.context.save?.yearNoteSummary) return null;

  const singlePayLabel =
    state.context.save?.yearNoteSummary?.balance > 0 ? t('global.singlePaymentLabel') : t('global.overPaidLabel');
  const tableContent = [
    { label: singlePayLabel, value: Math.abs(state.context.save?.yearNoteSummary?.balance) },
    { label: t('global.newTermAmountLabel'), value: state.context.save?.yearNoteSummary?.advancePaymentAmount },
  ];

  return (
    <EndStepHero heroImage={heroImage}>
      <EndStepCard title={title} content={content} buttonHref={buttonHref} buttonText={buttonText}>
        <Table>
          {state.context.save?.yearNoteSummary &&
            tableContent.map(
              item =>
                item.label && (
                  <Table.Row key={item.label}>
                    <span>{item.label}</span>
                    <span>{currency.euro(item.value)}</span>
                  </Table.Row>
                ),
            )}
          <Table.Row isFooter>
            <span>{footerLabel}</span>
            <span>{currency.euro(state.context.save?.yearNoteSummary?.checkoutAmount)}</span>
          </Table.Row>
        </Table>
      </EndStepCard>
    </EndStepHero>
  );
};
